import apiCtrl from '@/services/api/abstract/abstract-api.js';
export default {
  props: {
    entity: String,
    configUrl: String,
    paginationInSearch: {
      type: Boolean,
      default: false,
    },
    twoLine: Boolean,
    threeLine: Boolean,
    level: Number,
    defaultIcon: String,
    searchInput: Boolean,
    searchConfig: {
      type: Object,
      default: function() {
        return {
          constraint: {},
        };
      },
    },
    addSelectCheckbox: {
      type: Boolean,
      default: false,
    },
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      config: {},
      configReady: false,
      itemsReady: false,
      params: {
        search: '',
        page: 1,
      },
      page: 1,
      search: '',
      showPagination: false,
      pagination: {
        current_page: 1,
        from: 1,
        last_page: null,
        per_page: 15,
        to: null,
        total: null,
      },
    };
  },
  mounted() {
    if (this.searchInput) {
      this.itemsReady = true;
    } else {
      this.getEntities();
    }
    this.getConfig();
  },
  computed: {
    readyToList() {
      return this.configReady && this.itemsReady;
    },
    allItemsSelected() {
      return !this.items.find(item => {
        return !item.selected;
      });
    },
    anySelected() {
      return !!this.items.find(item => {
        return item.selected;
      });
    },
  },
  methods: {
    selectAllItems(value = true) {
      this.items.map(item => {
        this.$set(item, 'selected', value);
      });
    },
    onCheckAllClicked() {
      this.selectAllItems(!this.allItemsSelected);
    },
    getEntities() {
      this.itemsReady = false;
      let config = {};
      config.params = this.params;
      apiCtrl.get('/' + this.entity, config).then(res => {
        if (this.addSelectCheckbox) {
          this.items = res.data.data.map(item => {
            this.$set(item, 'selected', false);
            return item;
          });
        } else {
          this.items = res.data.data;
        }
        if (res.data.hasOwnProperty('meta')) {
          this.pagination = res.data.meta;
          this.showPagination = true;
        }
        this.$emit('entitiesloaded', true);
        this.itemsReady = true;
      });
    },
    getConfig() {
      this.configReady = false;
      const configUrl = this.configUrl ? this.configUrl : '/config/' + this.entity;
      apiCtrl.get(configUrl).then(res => {
        this.config = res.data.data;
        this.configReady = true;
      });
    },

    setPagination: function(meta) {
      this.pagination = meta;
      this.showPagination = true;
    },
  },
  watch: {
    page: function(val) {
      this.params.page = val;
      // console.log(val);
      console.log('PageCJHangeInListMixin');
      console.log({ paginationInSearch: this.paginationInSearch });
      if (!this.paginationInSearch) {
        console.log('GetEntitiesInListMixin');

        this.getEntities();
      }
    },
    paginationInSearch: function(val, oldval) {
      console.log('paginationInSearchCHange from' + oldval + ' to ' + val);
    },
    reload: function(val) {
      if (val) {
        this.getEntities();
      }
    },
  },
};
